// import { VNode } from '@vue/runtime-core';
import type { ElMessage } from 'element-plus';

export declare type ElMessageType = typeof ElMessage;

export interface CustomConfig4UtilsType {
  /**
   * 触发sentry统计请求时间：最小值
   * @default 3000
   */
  timeMin4Sentry?: number;
  /**
   * 触发sentry统计请求时间：最小值
   * 同时，此参数也作为ajax超时时间设置，单位毫秒
   * @default 5000
   */
  timeMax4Sentry?: number;
  /**
   * 用来显示消息
   */
  elMessage?: ElMessageType; // (options: ElMessageType) => void;
}

const CONFIG_4_UTILS_DEFAULT = {};

let config4Api: CustomConfig4UtilsType = {};

export function setUtilsCustomConfig(options: CustomConfig4UtilsType) {
  config4Api = { ...CONFIG_4_UTILS_DEFAULT, ...options };
}

export function getUtilsCustomConfig() {
  return config4Api;
}
